export default "__VITE_ASSET__BIo7F2T9__"